const { pick, isEmpty } = require('lodash');
const dedent = require('dedent');

const { entries } = Object;
const plans = {
  d2c: { label: 'D2C', },
  amazon: { label: 'Amazon', },
  both: { label: '両方', },
};
const tenantOptions = {
  multiSellers: {
    label: '追加セラーアカウント',
  },
  mercari: {
    label: 'メルカリ連携',
  },
  shopify: {
    label: 'Shopify連携',
  },
  rakuten: {
    label: '楽天連携',
  },
  yahoo: {
    label: 'Yahoo連携',
  },
  tts: {
    label: 'TikTok Shop連携',
  },
  qoo10: {
    label: 'Qoo10連携',
  },
  codAllEnabled: {
    label: '代引き指定可',
  },
};
const labelPdfTypes = {
  label40: {
    label: '40面',
  },
  label1: {
    label: '1面',
  },
};

module.exports = {
  generalSettingsFields: ({ tenant, senders = [], } = {}) => {
    return {
      autoCreatesInboundShipment: {
        label: '自動FBA納品プラン作成設定',
        type: 'boolean',
        displayValue: _ => ({ true: '有効', false: '無効', })[_ ?? false],
        validations: {
          defaultSender: _ => !_ || senders.some(_ => _.isDefault),
        },
        initialValue: false,
      },
      autoInboundShipmentQuantity: {
        label: '自動FBA納品プランを作成する入庫数 (標準以下)',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
        hidden: _ => !_.autoCreatesInboundShipment,
      },
      autoInboundShipmentLargeQuantity: {
        label: '自動FBA納品プランを作成する入庫数 (大型以上)',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
        hidden: _ => !_.autoCreatesInboundShipment,
      },
      autoInboundShipmentUnknownQuantity: {
        label: '自動FBA納品プランを作成する入庫数 (サイズ不明)',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
        hidden: _ => !_.autoCreatesInboundShipment,
      },
      labelPdfType: {
        label: '商品ラベルPDFタイプ',
        type: 'select',
        options: entries(labelPdfTypes).map(([k, v]) => ({ value: k, label: v.label })),
        validations: {
          required: v => !isEmpty(v),
        },
        initialValue: 'label40',
      },
      slipHeaderText: {
        label: '納品書ヘッダー部テキスト',
        type: 'text',
      },
      slipDefaultEnabled: {
        label: 'デフォルトで納品書同封',
        type: 'boolean',
        initialValue: false,
      },
      inventoryBuffer: {
        type: 'integer',
        label: '在庫バッファ数',
        initialValue: 0,
        hidden: _ => ['mercari', 'shopify', 'rakuten', 'yahoo', 'tts', 'qoo10'].every(_ => !tenant.tenantOptionValues?.includes(_)),
      },
      createsShippingRequestWithUnmappedItems: {
        type: 'boolean',
        label: '商品対応表が未登録の商品を含む受注でも出荷依頼を作成する',
        hint: '有効の場合、未登録の商品を除いた商品だけで出荷依頼を作成します',
        displayValue: _ => ({ true: '有効', false: '無効', })[_ ?? true],
        initialValue: true,
        hidden: _ => ['mercari', 'shopify', 'rakuten', 'yahoo', 'tts', 'qoo10'].every(_ => !tenant.tenantOptionValues?.includes(_)),
      },
      codFees: {
        type: 'text',
        label: '代引き手数料設定',
        placeholder: dedent`
          例)
          1-10000:800
          10001-20000:1000
          20001-:1500
        `,
        hint: '代引き金額がA円からB円までなら手数料500円の場合「A-B:500」と入力。C円以上1000円なら「C-:1000」。',
        rows: 5,
        validations: {
          format: _ => _ == null || _.split('\n').filter(_ => _).every(_ => _.match(/^\d+-\d*:\d+$/)),
        },
        hidden: _ => !tenant.tenantOptionValues?.includes('codAllEnabled'),
      },
      codCustomerCode: {
        type: 'string',
        label: 'お客様コード（代引き用）',
        hidden: _ => !tenant.tenantOptionValues?.includes('codAllEnabled'),
      },
    };
  },
  adminFields: ({ tags = [], } = {}) => {
    return {
      plan: {
        type: 'select',
        label: 'プラン',
        options: entries(plans).map(([k, v]) => ({ value: k, label: v.label })),
        validations: {
          required: v => !isEmpty(v),
        },
      },
      referrer: {
        type: 'string',
        label: '紹介者',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      tenantOptionValues: {
        type: 'multiSelect',
        label: 'オプション',
        options: entries(tenantOptions).map(([k, v]) => ({ value: k, label: v.label })),
      },
      allowsMultiNeko: {
        type: 'boolean',
        label: '複数でもネコポス',
        initialValue: false,
      },
      disablesDirectShelvingWarehouseCreation: {
        type: 'boolean',
        label: 'ダイレクト入庫で倉庫作成分を作成しない',
        initialValue: false,
      },
      tagIds: {
        type: 'multiSelect',
        label: 'タグ',
        options: tags.map(_ => ({ value: _.id, label: _.name })),
      },
      adminNote: {
        type: 'text',
        label: '管理者メモ',
      },
    };
  },
  plans,
};
